var installedModules = {};
var moduleToHandlerMapping = {
	7462: {
		getter: () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	35742: {
		getter: () => (__webpack_require__.e(5368).then(() => (() => (__webpack_require__(85368))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	70173: {
		getter: () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "17.0.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"5017": [
		7462,
		35742,
		70173
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({chunkMapping, installedModules, chunkId, moduleToHandlerMapping, promises, webpackRequire:__webpack_require__});
}